import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Indianapolis">
                <h1>Top Mobile App Development Company in Indianapolis</h1>
              </div>
              <p className="main_para">
                Digitize your business with efficient mobile apps based on the
                latest technologies and proven strategy. We are a premier
                partner for mobile app development Indianapolis to facilitate
                businesses right according to their requirements. As a leading
                Indianapolis app development company, we craft next-gen mobile
                experiences that drive engagement and boost conversions by 2X.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your App!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
